import 'whatwg-fetch';
import API, { GET_AUTH_ROOMS } from 'base/api';
import auth, { STORAGE_ROOMS_TOKEN } from 'base/auth';
import { fetchUserData } from 'modules/User/redux/fetchUserData';

export const LEAVE_ROOM = 'LEAVE_ROOM';
export const LEAVE_ROOM_BEGIN = 'LEAVE_ROOM_BEGIN';
export const LEAVE_ROOM_SUCCESS = 'LEAVE_ROOM_SUCCESS';
export const LEAVE_ROOM_ERROR = 'LEAVE_ROOM_ERROR';

export const leaveRoomBegin = () => ({
    type: LEAVE_ROOM_BEGIN
});

export const leaveRoomSuccess = ( data ) => ({
    type: LEAVE_ROOM_SUCCESS,
    payload: { data }
});

export const leaveRoomError = ( error ) => ({
    type: LEAVE_ROOM_ERROR,
    payload: { error }
});

export function leaveRoom (){
    return dispatch => {
      dispatch(leaveRoomBegin());
      return fetch(API.LEAVE_ROOM, GET_AUTH_ROOMS)
        .then(handleErrors)
        .then(res => res.json())
        .then(json => {
          dispatch(leaveRoomSuccess(json));
          dispatch(fetchUserData(auth.getToken(STORAGE_ROOMS_TOKEN)));
          return json;
        })
        .catch(error => dispatch(leaveRoomError(error.message)));
    };
  }

  function handleErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  }



// WEBPACK FOOTER //
// ./src/modules/User/redux/leaveRoom.js